import React from 'react'

import { Svg } from './Svg'

export interface DollarSignProps {
  color?: string
  hoverColor?: string
  className?: string
}

export function DollarSign({ color, hoverColor, className }: DollarSignProps): JSX.Element {

  return (
    <Svg $strokeColor={color} $strokeHoverColor={hoverColor} $fillColor={color} $fillHoverColor={hoverColor} className={className} width="100%" height="100%" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0)">
        <path d="M16 1.33334V30.6667" className='stroke' stroke="#D7D7CD" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M22.6667 6.66666H12.6667C11.429 6.66666 10.242 7.15832 9.36684 8.03349C8.49167 8.90866 8 10.0956 8 11.3333C8 12.571 8.49167 13.758 9.36684 14.6332C10.242 15.5083 11.429 16 12.6667 16H19.3333C20.571 16 21.758 16.4917 22.6332 17.3668C23.5083 18.242 24 19.429 24 20.6667C24 21.9043 23.5083 23.0913 22.6332 23.9665C21.758 24.8417 20.571 25.3333 19.3333 25.3333H8" className='stroke' stroke="#D7D7CD" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="100%" height="100%" className='fill' />
        </clipPath>
      </defs>
    </Svg>
  )

}
